import { render, staticRenderFns } from "./StudentPracticalWorks.vue?vue&type=template&id=265ab30a&scoped=true"
import script from "./StudentPracticalWorks.vue?vue&type=script&lang=js"
export * from "./StudentPracticalWorks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "265ab30a",
  null
  
)

export default component.exports